var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 358.5",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 358.5"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:red}.st1{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.5,56.1c-5.9-21.9-23.2-39.2-45.1-45.1C416.3,0,256,0,256,0S95.7,0,55.7,10.5 c-21.5,5.9-39.2,23.6-45.1,45.5C0,96.2,0,179.2,0,179.2s0,83.5,10.5,123.1c5.9,21.9,23.2,39.2,45.1,45.1c40.5,11,200.3,11,200.3,11 s160.3,0,200.3-10.5c21.9-5.9,39.2-23.2,45.1-45.1C512,262.7,512,179.7,512,179.7S512.4,96.2,501.5,56.1z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205,256l133.3-76.8L205,102.5V256z",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e5e6132f56bf262c7b7ce8b0fe25d38e.svg";
export { ForwardRef as ReactComponent };